const shuttleReports = {
  actions: {
    export: 'Exportar',
  },

  table: {
    headers: {
      tripId: 'Identificação de viagem:',
      routingType: 'Tipo de Roteirização',
      reservationId: 'Id de reserva',
      externalId: 'Identificador Externo',
      reservationStatus: 'Status da reserva',
      tripStatus: 'Status de Viagem',
      date: 'Data',
      dateType: 'Tipo de Data',
      passenger: 'Passageiro',
      email: 'E-mail',
      phone: 'Telefone',
      seats: 'Assentos',
      supplier: 'Fornecedor',
      shuttle: 'Transporte',
      line: 'Linha',
      from: 'De',
      to: 'Para',
      driver: 'Motorista',
      vehicle: 'Veículo',
      paymentType: 'Tipo de pagamento',
      paymentDetails: 'Detalhes de pagamento',
      profile: 'Perfil',
      shuttleArea: 'Zona',
      dropOff: 'Devolução',
      area: 'Zona',
      direction: 'Direção',
      price: 'Preço',
      pickedTime: 'Horário Selecionado',
      droppedTime: 'Tempo ignorado',
      noshowTime: 'Tempo de não comparência',
      shuttleFare: 'tarifa de transporte',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'Novo',
          onhold: 'Em espera',
          cancelled: 'Cancelado',
          routing: 'Roteirizando',
          routed: 'Roteirizado',
          picked: 'Recolhido',
          dropped: 'Deixado',
          noshow: 'Não comparência',
        },
      },
    },

    filters: {
      reservationStatus: {
        options: {
          new: 'Novo',
          onhold: 'Em espera',
          cancelled: 'Cancelado',
          routing: 'Roteirizando',
          routed: 'Roteirizado',
          picked: 'Recolhido',
          dropped: 'Deixado',
          noshow: 'Não comparência',
        },
      },
      tripStatus: {
        options: {
          new: 'Novo',
          inroute: 'Em rota',
          sent: 'Enviado',
          approved: 'Aprovado',
          pickingUp: 'Recolhimento',
          done: 'Ok',
          cancelled: 'Cancelado',
        },
      },
      routingType: {
        options: {
          bus: 'Autocarro',
          demand: 'Demanda',
          dynamic: 'Dinâmico',
        },
      },
    },
  },
  tableSummary: {
    title: 'Relatórios de transporte',
    headers: {
      trips: 'Viagens',
      reservations: 'Reservas',
      passengers: 'Passageiros',
      uniquePassengers: 'Passageiros únicos',
    },
  },
};

export default shuttleReports;
